// services/courseService.js

import axios from "axios";
import configuration from "@/utils/configuration";

export const profileService = {

//-----------  Certificate Management ------------
getConsentForAdmin(params) {
  return axios.get(`${configuration.backUrl}/users/management/consent`, {
    withCredentials: true,
    params:params
  });
},
postCertificate(payload) {
  return axios.post(`${configuration.backUrl}/user-certificate`, payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
},
patchCertificate(params, payload) {
  return axios.patch(`${configuration.backUrl}/user-certificate`, payload, {
    withCredentials: true,
    params:params
  });
},
deleteCertificate(certificateId) {
  return axios.delete(`${configuration.backUrl}/user-certificate`,{
    withCredentials: true,
    params: { user_certificate_id: certificateId },
  });
},
getCertificateByUserId(userId) {
  return axios.get(`${configuration.backUrl}/user-certificate/user`,{
    withCredentials: true,
    params: { user_id: userId },
  });
},
getCurrentUserCertificate() {
  return axios.get(`${configuration.backUrl}/user-certificate/current-user`,{
    withCredentials: true,
  });
},

};

